import React from 'react';
import { FileText, DollarSign, Smartphone, TrendingUp, Package, CheckCircle, ArrowRight } from 'lucide-react';

const Servicios = () => {
  const tramites = [
    { nombre: 'Registro de Empresa', tiempo: '5 días hábiles' },
    { nombre: 'Permisos de Operación', tiempo: '3 días hábiles' },
    { nombre: 'Licencias Sanitarias', tiempo: '7 días hábiles' },
    { nombre: 'Certificaciones', tiempo: '10 días hábiles' }
  ];

  const tiposFinanciamiento = [
    {
      nombre: 'Crédito Empresarial',
      monto: 'Hasta $500,000 MXN',
      tasa: '8.5% anual',
      plazo: '5 años'
    },
    {
      nombre: 'Microcréditos',
      monto: 'Hasta $50,000 MXN',
      tasa: '6.5% anual',
      plazo: '2 años'
    },
    {
      nombre: 'Capital Semilla',
      monto: 'Hasta $200,000 MXN',
      tasa: 'Sin interés',
      plazo: '3 años'
    }
  ];

  const beneficiosDigitales = [
    'Capacitación en herramientas digitales',
    'Desarrollo de sitios web y e-commerce',
    'Marketing digital y redes sociales',
    'Sistemas de punto de venta',
    'Facturación electrónica',
    'Cloud computing y almacenamiento'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80" 
            alt="Servicios"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="text-5xl font-bold text-white mb-4">Servicios</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Descubre todos los servicios que la SETY ofrece para impulsar tu negocio y desarrollo profesional.
          </p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Portal de Trámites */}
        <section id="tramites" className="mb-20 scroll-mt-24">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 lg:p-12">
                <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                  <FileText className="h-7 w-7 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Portal de Trámites</h2>
                <p className="text-gray-600 mb-6">
                  Realiza tus trámites de manera rápida y eficiente a través de nuestro portal en línea.
                  Todos los servicios gubernamentales en un solo lugar.
                </p>
                <button className="px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium flex items-center gap-2">
                  Ir al Portal
                  <ArrowRight className="h-5 w-5" />
                </button>
              </div>
              
              <div className="bg-gradient-to-br from-slate-50 to-gray-100 p-8 lg:p-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">Trámites Disponibles</h3>
                <div className="space-y-4">
                  {tramites.map((tramite, index) => (
                    <div key={index} className="flex items-center justify-between bg-white rounded-lg p-4 border border-gray-200">
                      <span className="text-gray-900 font-medium">{tramite.nombre}</span>
                      <span className="text-sm text-gray-600">{tramite.tiempo}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Financiamiento */}
        <section id="financiamiento" className="mb-20 scroll-mt-24">
          <div className="text-center mb-12">
            <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mx-auto mb-6">
              <DollarSign className="h-7 w-7 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Financiamiento</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Opciones de financiamiento para emprendedores y empresarios yucatecos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {tiposFinanciamiento.map((tipo, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-xl hover:border-[#8B1538] transition-all duration-300">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{tipo.nombre}</h3>
                <div className="space-y-3 mb-6">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Monto máximo</span>
                    <span className="font-semibold text-gray-900">{tipo.monto}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Tasa</span>
                    <span className="font-semibold text-gray-900">{tipo.tasa}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Plazo</span>
                    <span className="font-semibold text-gray-900">{tipo.plazo}</span>
                  </div>
                </div>
                <button className="w-full px-4 py-2 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium">
                  Solicitar
                </button>
              </div>
            ))}
          </div>
        </section>

        {/* Transformación Digital */}
        <section id="transformacion-digital" className="mb-20 scroll-mt-24">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-3">
              <div className="order-2 lg:order-1 bg-gradient-to-br from-slate-50 to-gray-100 p-8 lg:p-12">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">Beneficios del Programa</h3>
                <div className="space-y-3">
                  {beneficiosDigitales.map((beneficio, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle className="h-5 w-5 text-[#8B1538] flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{beneficio}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="order-1 lg:order-2 p-8 lg:p-12">
                <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                  <Smartphone className="h-7 w-7 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Estrategia de Transformación Digital</h2>
                <p className="text-gray-600 mb-6">
                  Impulsa la adopción de herramientas digitales en tu empresa. Desde sitios web hasta 
                  sistemas de gestión, te acompañamos en la digitalización de tu negocio.
                </p>
                <div className="space-y-4">
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4">
                    <div className="font-semibold text-gray-900 mb-1">Inversión</div>
                    <div className="text-2xl font-bold text-[#8B1538]">$0 - Completamente Gratuito</div>
                  </div>
                  <button className="px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium flex items-center gap-2">
                    Inscribirse al Programa
                    <ArrowRight className="h-5 w-5" />
                  </button>
                </div>
              </div>
              
              <div className="order-3 hidden lg:flex items-center justify-center bg-white">
                <img 
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" 
                  alt="Digital Transformation"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Fomento a la Inversión */}
        <section id="fomento-inversion" className="mb-20 scroll-mt-24">
          <div className="text-center mb-12">
            <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mx-auto mb-6">
              <TrendingUp className="h-7 w-7 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Fomento a la Inversión</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Facilitamos y promovemos la inversión en Yucatán con incentivos y apoyo especializado
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-8 border border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Incentivos Fiscales</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Reducción de impuestos hasta 50% los primeros 3 años</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Exención de derechos de trámites</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Créditos preferentes para infraestructura</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Sectores Prioritarios</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Tecnología e Innovación</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Turismo Sostenible</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Agroindustria</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 bg-[#8B1538] rounded-full mt-2"></span>
                  <span>Manufactura Avanzada</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Comercialización */}
        <section id="comercializacion" className="scroll-mt-24">
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 lg:p-12">
                <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-6">
                  <Package className="h-7 w-7 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Comercialización</h2>
                <p className="text-gray-600 mb-8">
                  Conectamos a productores locales con mercados nacionales e internacionales. 
                  Te apoyamos en la estrategia comercial, logística y promoción de tus productos.
                </p>
                
                <div className="grid grid-cols-1 gap-4 mb-8">
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 flex items-center gap-4">
                    <div className="text-3xl font-bold text-[#8B1538]">150+</div>
                    <div className="text-sm text-gray-600">Empresas Conectadas</div>
                  </div>
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 flex items-center gap-4">
                    <div className="text-3xl font-bold text-[#8B1538]">30+</div>
                    <div className="text-sm text-gray-600">Países de Exportación</div>
                  </div>
                  <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg p-4 flex items-center gap-4">
                    <div className="text-3xl font-bold text-[#8B1538]">$500M</div>
                    <div className="text-sm text-gray-600">Valor de Exportaciones</div>
                  </div>
                </div>

                <button className="px-8 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium inline-flex items-center gap-2">
                  Solicitar Asesoría
                  <ArrowRight className="h-5 w-5" />
                </button>
              </div>
              
              <div className="hidden lg:flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-gray-100">
                <img 
                  src="https://illustrations.popsy.co/amber/online-shopping.svg" 
                  alt="Comercialización Illustration"
                  className="w-full max-w-md"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Servicios;
